// extracted by mini-css-extract-plugin
export default {"container":"ConfigurationTab_container__ldErO"};